import { styled } from '@mui/material/styles'
import { themeSpacing } from 'eezy-components'

export const Container = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding-bottom: ${themeSpacing(3)};
  text-align: center;
`
